// @flow

const groupItems = () => [
  [
    {
      id: 'none',
      title: 'без группировки',
    },
    {
      id: 'by_group_complexes',
      title: 'комплектам (групповой талон)',
    },
    {
      id: 'by_camp_complexes',
      title: 'комплектам лагеря (групповой талон)',
    },
    {
      id: 'by_payment_method',
      title: 'способу расчёта',
    },
    {
      id: 'by_items_and_complexes_and_cost',
      title: 'стоимости продукции и комплектам',
    },
  ],
  ['none'],
]

export default groupItems
